module.exports = __webpack_public_path__ + "static/media/Mulish-Light.34628495.svg";